import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { FailureToast } from '../components/toasts/FailureToast';
import { SuccessToast } from '../components/toasts/SuccessToast';
import { generateSitemap } from '../modules/settings/redux/SettingsCRUD';

export type ErrorResponse = {
  message: string;
  errors: { [key: string]: Array<string> };
};

export const successToast = (message: string, title?: string): void => {
  toast(SuccessToast({ message, title }));
};

export const failureToast = (e: any): void => {
  const error = e as AxiosError<ErrorResponse>;
  const responseData = error?.response?.data as Partial<ErrorResponse> | undefined;
  const message = responseData?.message ?? error?.message ?? 'Something went wrong.';
  const errors = responseData?.errors;

  // this is for custom exception thrown from the backend
  if (errors === undefined) {
    toast(FailureToast({ message }));
    return;
  }

  if (typeof errors === 'string') {
    toast(FailureToast({ message: errors, title: message }));
    return;
  }

  const firstKey = Object.keys(errors)[0];
  const firstMessage = firstKey != null && Array.isArray(errors[firstKey]) ? errors[firstKey][0] : null;
  toast(
    FailureToast({
      message: firstMessage ?? message ?? 'Something went wrong.',
      title: message,
    })
  );
};

type CustomFailureToastProp = {
  title?: string;
  message: string;
};
export const customFailureToast = ({
  title = 'Something went wrong.',
  message,
}: CustomFailureToastProp) => {
  toast(
    FailureToast({
      title,
      message,
    })
  );
};

export const handlePaginate = async <T>(page_url: string) => {
  const response = await axios.get<{ value: PaginatedValue<T> }>(page_url, {
    baseURL: '',
  });
  return response.data.value;
};

export class PaginatedValue<T = any> {
  data: Array<T> = [];
  current_page: number = 0;
  first_page_url: string = '';
  from: number = 0;
  last_page: number = 0;
  last_page_url: string = '';
  links: Array<PaginateLink> = [];
  next_page_url: string | null = null;
  path: string = '';
  per_page: number = 0;
  prev_page_url: string | null = null;
  to: number = 0;
  total: number = 0;
}

export class PaginateLink {
  active: boolean = false;
  label: string = '';
  url: string | null = null;
}

export const defaultPaginatedValue: PaginatedValue = {
  ...new PaginatedValue(),
  current_page: 1,
  links: [
    new PaginateLink(),
    { ...new PaginateLink(), label: '1', active: true },
    new PaginateLink(),
  ],
};

export const handleGenerateSitemap = async (
  loading: boolean,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setLoading(true);

  try {
    const result = await generateSitemap();
    console.log(result)
    successToast('Sitemap has been generated.');
    window.open(result, '_blank')?.focus();
    setLoading(false);
  } catch (error) {
    failureToast(error);
    setLoading(false);
  }
};
